<template>
  <span :class="getClass()"><slot /></span>
</template>

<script>
export default {
  name: 'MainNavigationItem',
  props: {
    text: String,
    isActive: Boolean
  },
  methods: {
    getClass () {
      if (this.isActive) { return 'navigation-item active'; }
      return 'navigation-item inactive';
    }
  }
};
</script>

<style lang="scss" scope>
@import '@/assets/stylesheets/variables.scss';

.navigation-item {
  color: #00A0CA;
  position: relative;
  font-size: 1.1em;
  font-weight: 600;
  user-select: none;
  cursor: pointer;

  border-radius: $border-radius;
  transition: padding 100ms cubic-bezier(0,.95,.47,.92);

  &.active {
    color: white;
    background-color: $secondary;
    //border: 1px solid $secondary;
    padding: 14px 16px 14px 16px;
    background: linear-gradient($secondary 0%, $secondary 100%);
  }

  &.inactive {
    color: #71e3ff;
    //border: 1px solid $secondary
  }
}
</style>
